// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__dkCWC","overflowing":"ReadFullNote_overflowing__14HY-"};